const siteMap = (isLogin, memberLevel) => {
  let myProfileMenu = [
    {
      key: 'my-profile',
      label: '我的帳戶',
      route: { name: 'my-profile-personal-details' },
    },
    {
      key: 'playlists',
      label: '專案選曲',
      route: { name: 'my-music-playlists' },
    },
    {
      key: 'search-history',
      label: '搜尋歷史',
      route: { name: 'my-music-search-history' },
    },
    {
      key: 'play-history',
      label: '播放紀錄',
      route: { name: 'my-music-play-history' },
    },
    {
      key: 'download-history',
      label: '下載紀錄',
      route: { name: 'my-music-download-history' },
    },
    {
      key: 'preview-tool',
      label: '影音結合體會',
      route: { name: 'my-music-preview-tool' },
    },
  ];

  if (memberLevel <= 2) {
    myProfileMenu = myProfileMenu.filter((item) => item.key === 'my-profile');
  }

  if (memberLevel === 3) {
    myProfileMenu = myProfileMenu.filter((item) => !['preview-tool'].includes(item.key));
  }

  const siteMapList = [
    {
      key: 'explore',
      label: '探索',
      subList: [
        {
          label: '主題',
          key: 'themes',
          route: {
            name: 'explore-type',
            params: {
              type: 'themes',
            },
          },
          gtmClass: 'GTM_POINT_home_footer_explore_themes',
        },
        {
          label: '氣氛',
          key: 'moods',
          route: {
            name: 'explore-type',
            params: {
              type: 'moods',
            },
          },
          gtmClass: 'GTM_POINT_home_footer_explore_moods',
        },
        {
          label: '曲風',
          key: 'genres',
          route: {
            name: 'explore-type',
            params: {
              type: 'genres',
            },
          },
          gtmClass: 'GTM_POINT_home_footer_explore_genres',
        },
        {
          label: '歌單',
          key: 'playlists',
          route: {
            name: 'explore-type',
            params: {
              type: 'playlists',
            },
          },
          gtmClass: 'GTM_POINT_home_footer_explore_playlists',
        },
        {
          label: '專輯',
          key: 'albums',
          route: {
            name: 'explore-type',
            params: {
              type: 'albums',
            },
          },
          gtmClass: 'GTM_POINT_home_footer_explore_albums',
        },
        {
          label: '品牌',
          key: 'labels',
          route: {
            name: 'explore-type',
            params: {
              type: 'labels',
            },
          },
          gtmClass: 'GTM_POINT_home_footer_explore_labels',
        },
      ],
    },
    {
      key: 'my-profile',
      label: '會員專區',
      subList: myProfileMenu,
    },
    {
      key: 'licensing',
      label: '法律聲明',
      subList: [
        {
          label: '使用條款',
          key: 'terms',
          route: { name: 'licensing-terms' },
          gtmClass: 'GTM_POINT_home_footer_explore_terms',
        },
        {
          label: '隱私權政策',
          key: 'privacy',
          route: { name: 'licensing-privacy' },
          gtmClass: 'GTM_POINT_home_footer_explore_privacy',
        },
        {
          label: 'COOKIES 政策',
          key: 'cookies',
          route: { name: 'licensing-cookies' },
          gtmClass: 'GTM_POINT_home_footer_explore_cookies',
        },
      ],
    },
    {
      key: 'other',
      label: '關於',
      subList: [
        {
          label: '授權服務',
          key: 'licensing',
          route: { name: 'licensing' },
          gtmClass: 'GTM_POINT_home_footer_about_licensing',
        },
        {
          label: '關於我們',
          key: 'aboutUs',
          route: { name: 'front-about-us' },
          gtmClass: 'GTM_POINT_home_footer_about_about-us',
        },
        {
          label: '聯絡我們',
          key: 'contact',
          route: { name: 'front-contact' },
          gtmClass: 'GTM_POINT_home_footer_about_contact-us',
        },
      ],
    },
  ];

  if (isLogin) {
    return siteMapList;
  }

  return siteMapList.filter((item) => item.key !== 'my-profile');
};

export default siteMap;
